import { render, staticRenderFns } from "./templateTable.vue?vue&type=template&id=0108701f&scoped=true"
import script from "./templateTable.vue?vue&type=script&lang=js"
export * from "./templateTable.vue?vue&type=script&lang=js"
import style0 from "./templateTable.vue?vue&type=style&index=0&id=0108701f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108701f",
  null
  
)

export default component.exports